import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RestfulService } from '@app/service/restful.service';
import { BehaviorSubject } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  public language: BehaviorSubject<any> = new BehaviorSubject('ko');
  public language$ = this.language.asObservable();

  constructor(
    private restful: RestfulService,
    private translate: TranslateService
  ) {
  }

  // 다국어 설정된 언어 리스트를 가져온다.
  getLanguageList(): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'language',
        version: '1.0',
        action: 'getLanguageList'
      }, {}
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 다국어 언어 리스트를 가져온다.
  getLanguageConfigList(): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'language',
        version: '1.0',
        action: 'getLanguageConfigList'
      }, {}
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 다국어 추가
  addLanguage(seq: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'language',
        version: '1.0',
        action: 'addLanguage'
      }, {
        seq: seq
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 기본언어 설정
  setLanguageDefault(seq: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'language',
        version: '1.0',
        action: 'setLanguageDefault'
      }, {
        seq: seq
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 기본언어 설정
  delLanguage(seq: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'language',
        version: '1.0',
        action: 'delLanguage'
      }, {
        seq: seq
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 다국어 설정 리스트를 가져온다.
  getLanguageContentsList(): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'language',
        version: '1.0',
        action: 'getLanguageContentsList'
      }, {}
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  saveContents(form: any): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'language',
        version: '1.0',
        action: 'saveContents'
      }, form.value
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  delContents(seq: any): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'language',
        version: '1.0',
        action: 'delContents'
      }, {
        seq: seq
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  addMenu(): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'language',
        version: '1.0',
        action: 'addMenu'
      }, {}
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  jsonDownload():Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'language',
        version: '1.0',
        action: 'jsonDownload'
      }, {}
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  jsonUploadServer():Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'language',
        version: '1.0',
        action: 'jsonUploadServer'
      }, {}
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }
}